export const API_ROUTES = {
  REGISTRATION: "user/registration",
  LOGIN: "user/login",

  STATUS_LIST: "user/status/list",

  ACCOUNT: "user/account",
  ACCOUNT_UPDATE: "user/account/update",
  CHANGE_MALL: "user/mall",

  MALL_LIST: "place/mall/list",

  TRANSACTIONS: "transaction/list/",
  TRANSACTION_BONUSES: "transaction/bonus/list/",
  TRANSACTION_BONUS: "transaction/bonus/get/",

  NEWS_LIST: "news/list/",
  NEWS_ITEM: "news/get/",

  BONUSES_LIST: "bonus/list/",
  BONUS: "bonus/get/",
  BONUS_REQUEST: "bonus/request/",
  BONUS_ACTIVATE: "bonus/activate/",
  BONUS_CATEGORIES: "bonus/category/list/",

  SEND_INVITE: "friend/invite/send/",
  CHECK_INVITE: "friend/invite/check/",

  CONTACT: "request/send/",
  CONTACT_TYPES: "request/type/list/",

  VISIT_BONUS: "bonus/visit/send/",

  SERVICE: "service/data/",
};

export const api_key = process.env.REACT_APP_API_KEY;
export const baseURL = process.env.REACT_APP_BASE_URL;

export function defaultOptions() {
  const mall_id = localStorage.getItem("mall_id");

  return { api_key, mall_id };
}
